/**
 * Color Filters
 */
$('.js-show-more-color-filters').on('click', function(e) {
  e.preventDefault();
  $('.ColorSwatchItem--hidden').removeClass('ColorSwatchItem--hidden');
  $(this).hide();
});

/**	
 * Price Filter Sorted	
 */	
var $priceFilterWarp = $('.CollectionFilters .Collapsible---price .Linklist');	
$priceFilterWarp.each(function() {	
  var $container = $(this);	
  var $filterItems = $container.find('.Link');	
  var items = $filterItems.toArray().map(function(item) {	
    return {	
      el: $(item).parent(),	
      price: parseInt($(item).data('tag').split('-')[1]),	
    };	
  });	
  var sortedItems = items.sort(function(a, b) {	
    return b.price - a.price;	
  });	

  sortedItems.forEach(function(item) {	
    $container.prepend(item.el);	
  });	
});

/**
 * Reorder size filters
 */
var sizeOrder = ['xs', 's', 's-m', 'm', 'l', 'l-xl', 'xl', '2xl', '2xl-3xl', '3xl', '4xl', 'plus', 'regular', 'os'];
sizeOrder.reverse().forEach(function(size) {
  $('[data-tag="size_' + size + '"]').each(function() {
    var sizeItem = $(this).parent();
    var sizeList = sizeItem.parent();
    sizeList.prepend(sizeItem);
  });
});

/**
 * Color swatches
 */
var $collectionSection = $('.CollectionSection');
  
if ($collectionSection.length) {
  var settings = $collectionSection.data('section-settings');
  var colorTags = settings.currentTags.filter(function(item) {
    return item.indexOf('color_') !== -1;
  });
  
  if (colorTags.length) {
    var colorNames = colorTags.map(function(color) {
      return color.replace('colro_', '');
    });

    window.handleColorSwitchPreselect(colorNames);
  }
}


/**
 * Initial Collection Colors
 */
$('.ProductItem').each(function() {
  var $item = $(this);

  var $selectedInput = $item.find('.ColorSwatch__Radio:checked');
  var variantUrl = $selectedInput.attr('data-variant-url');

  $item.find('.ProductItem__Title > a').attr('href', variantUrl);
  $item.find('.ProductItemSlider a').attr('href', variantUrl);
  $item.find('.ProductItemImages a').attr('href', variantUrl);

  var selectedColor = $selectedInput.data('color-handle');
  handleColorSwitchImages($item, selectedColor);
});


/**
 * Product Item Colors
 */
$('.js-show-all-colors').on('click', function(e) {
  e.preventDefault();
  $(this).siblings('.ProductItem__ColorSwatchItem').show();
  $(this).remove();
});


/**
 * Product mobile hierarchy
 */
$('.RootCollections__Current').on('click', function(e) {
  e.preventDefault();
  $(this).toggleClass('open');
});